export const DEFAULT_ADULT_TRAVELING = 2;
export const DEFAULT_CHILDREN_TRAVELING = 0;
export const DEFAULT_INFANTS_TRAVELING = 0;
export const MIN_ADULT_TRAVELING = 1;
export const MIN_CHILDREN_TRAVELING = 0;
export const MIN_INFANTS_TRAVELING = 0;
